import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { isProfilingEnabled } from '@src/app/core/utils/feature-flags.util';
import { AuthSelectors } from '@src/app/store/auth/auth.selectors';
import { combineLatest, filter, map, take } from 'rxjs';

/**
 * Guard que protege rutas exclusivas para usuarios con perfil Poseedor Final
 * (Integral o Coste Estándar, o Productor con POSEE_ID PI/PC).
 *
 * Comportamiento:
 * - Si VIEW_PF=false (perfilado desactivado): redirige a /services mediante UrlTree.
 * - Si VIEW_PF=true (perfilado activo): espera a que selectedCompany esté cargado
 *   en el store y luego comprueba selectIsPoseedorFinal.
 *   - true  → permite acceso
 *   - false → redirige a /services mediante UrlTree
 *
 * Aplica a las rutas cuyos servicios están en ECODESIGN_PF_ONLY_ROUTES
 * (p. ej. /services/waste-consulting).
 */
export const poseedorFinalGuard: CanActivateFn = () => {
  const router = inject(Router);

  if (!isProfilingEnabled()) {
    return router.createUrlTree(['/services']);
  }

  const store = inject(Store);

  return combineLatest([
    store.select(AuthSelectors.selectSelectedCompany),
    store.select(AuthSelectors.selectIsPoseedorFinal),
  ]).pipe(
    filter(([company]) => !!company?.TIPO_TERCERO),
    take(1),
    map(([, isPF]) => {
      if (isPF) {
        return true;
      }
      return router.createUrlTree(['/services']);
    }),
  );
};
